module.exports = __webpack_public_path__ + "img/单产ico.7870e2a3.png";